export default {
  props: {
    typeaheads: {
      type: Object,
      default: () => {}
    },

    transportIndex: {
      type: Number,
      required: true
    },

    transport: {
      type: Object,
      required: true
    },

    visitorIndex: {},
    errors: {}
  },

  computed: {
    inputError () {
      return this.getErrorVisitorTransport(this.visitorIndex, this.transportIndex, this.inputName)
    },

    hasInputErrors () {
      return this.hasErrorVisitorTransport(this.visitorIndex, this.transportIndex, this.inputName)
    }
  },

  methods: {
    selectTransportTypeahead (selected) {
      if (!(selected instanceof Object)) {
        return
      }

      this.transport.type = selected.type
      this.transport.number = selected.number
      this.transport.mark = selected.mark
      this.transport.owner = selected.owner
      this.transport.color = selected.color
      this.transport.model = selected.model
      this.transport.trailer = selected.trailer
    }
  }
}
